"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = TcombFormReactWidgetsDateTimePickerTemplate;

var _react = require("react");

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var DateTimePicker = require("react-widgets/lib/DateTimePicker"); // only load the datetimepicker and nothin else, the whole react-widgets suite is too much.
var classnames = require("classnames");
var moment = require("moment");
var dateContainerStyle = {
    paddingLeft: 0, paddingTop: 0, paddingBottom: 0
};
// this is a tcomb form template --> https://gcanti.github.io/tcomb-form/guide/index.html#templates
// wraps the datetime picker from react widgets to use it within tcomb-form (through a tempalte function)
function TcombFormReactWidgetsDateTimePickerTemplate(locals) {
    var formGroupClasses = {
        "form-group": true,
        "has-feedback": true,
        "has-error": locals.hasError
    };
    return React.createElement("div", { className: classnames(formGroupClasses) }, locals.label ? React.createElement("label", { className: "control-label" }, locals.label) : null, React.createElement(DateTimePicker, { style: dateContainerStyle, disabled: locals.disabled, className: "form-control", initialView: "month", finalView: "year", time: false, value: locals.value === null ? null : moment(new Date(locals.value)).isValid() ? new Date(locals.value) : moment(locals.value).isValid() ? locals.value : null, editFormat: locals.config.momentDateEditFormat ? locals.config.momentDateEditFormat : "DD.MM.YYYY", format: locals.config.momentDateFormatterString, onChange: function onChange(date, dateStr) {
            // return null if the date was not parseable!
            var dateMoment = moment(date);
            if (dateMoment.isValid()) {
                locals.onChange(date.toString());
            } else {
                locals.onChange(null);
            }
        } }), locals.error ? React.createElement("span", { className: "help-block error-block" }, locals.error) : null, locals.help ? React.createElement("span", { className: "help-block" }, locals.help) : null);
}
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/TcombReactWidgetsDateTemplate.tsx
 ** module id = 1306
 ** module chunks = 0
 **/